exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link{font-size:16px}.white{color:#FFF}.black{color:#000}\n", ""]);

